<template>
  <div class="position-relative">
    <DynamicHeader
      @redirectUserToPage="redirectToHomePage"
      headerTitle="Usuários"
    />

    <AddButton title="Adicionar Usuário" @open="createUser"/>

    <div class="pt-3">
      <span class="page-delimiter"></span>
    </div>
    <div class="pt-3">
      <CreateOrUpdateUserModal
          v-if="activeModalName === 'CreateOrUpdateUser'"
          :activeModalName="activeModalName"
          :title="title"
          :user-data="userData"
          @close="closeModal"
          @hideOrShowLoader="hideOrShowLoader"/>
      <UsersCard @open="openModal" @hideOrShowLoader="hideOrShowLoader"/>
    </div>
  </div>
</template>

<script>
import CreateOrUpdateUserModal from "@/components/modals/CreateOrUpdateUserModal.vue";
import AddButton from "@/components/buttons/AddButton.vue";
import UsersCard from '@/components/cards/UsersCard.vue';
import {useStore, mapGetters} from "vuex";
import {useRouter} from "vue-router";
import DynamicHeader from "@/components/Headers/DynamicHeader.vue";

export default {

  data() {
    return {
      store: useStore(),
      router: useRouter(),
      userData: {},
      title: '',
    }
  },

  components: {
    CreateOrUpdateUserModal,
    UsersCard,
    AddButton,
    DynamicHeader
  },

  computed: {
    ...mapGetters({
      getType: 'getType',
      activeModalName: 'getModalName',
    }),
  },

  methods: {
    redirectToHomePage() {
      this.router.push({ name: this.getType === 'admin' ? 'Home' : 'Disciplines'})
    },

    closeModal() {
      this.store.dispatch('clearModalData')
    },

    openModal(user) {
      this.store.dispatch('clearModalData')
      this.title = 'Atualizar Usuário';
      this.userData = user;

      setTimeout(() => {
        this.store.dispatch('setModalData', { modalName: 'CreateOrUpdateUser', formModal: true })
      }, 0)
    },

    createUser() {
      this.userData = {};
      this.title = 'Criar Usuário';

      setTimeout(() => {
        this.store.dispatch('setModalData', { modalName: 'CreateOrUpdateUser', formModal: true })
      }, 0)
    },

    hideOrShowLoader(value) {
      if (value === true) {
        this.$store.dispatch('setLoadingState', {loadignState: true, loadingView: 'usersList'})
      } else if (value === false) {
        this.$store.dispatch('setLoadingState', {loadignState: false})
      }
    }
  }
}
</script>
